import { useDispatch, useSelector } from "react-redux";
import Modal from "../UI/Modal";
import { closeFormModal, openViewModal } from "../../store/reducers/talentos/talentos.reducer";
import { useEffect, useState } from "react";
import {
  createTalentoThunk,
  updateTalentoThunk,
  getTalentosThunk,
  getTalentoByIdThunk,
} from "../../store/reducers/talentos/talentos.thunks";
import Loader from "../UI/Loader";
import Alert from "../UI/Alert";
import { toast } from 'react-toastify';

const TalentoFormModal = () => {
  const dispatch = useDispatch();
  const {
    formModalOpen,
    formMode,
    selectedTalento,
    formLoading,
    formError,
    page,
    search,
  } = useSelector((state) => state.talentos);

  const [formData, setFormData] = useState({
    nombre: "",
    descripcion: "",
  });

  useEffect(() => {
    if (formMode === "edit" && selectedTalento) {
      setFormData({
        nombre: selectedTalento.nombre || "",
        descripcion: selectedTalento.descripcion || "",
      });
    } else {
      setFormData({
        nombre: "",
        descripcion: "",
      });
    }
  }, [formMode, selectedTalento, formModalOpen]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formMode === "create") {
      const result = await dispatch(createTalentoThunk(formData));
      if (result.meta.requestStatus === "fulfilled") {
        const createdId = result.payload.data.id;
        // Recargar la lista después de crear
        dispatch(getTalentosThunk({ page: 1, search: "" }));
        toast.success('Talento creado exitosamente');
        // Abrir modal de vista con el nuevo registro
        await dispatch(getTalentoByIdThunk(createdId));
        dispatch(openViewModal());
      }
    } else {
      const result = await dispatch(
        updateTalentoThunk({
          id: selectedTalento.id,
          payload: formData,
        })
      );
      if (result.meta.requestStatus === "fulfilled") {
        // Recargar la lista después de actualizar
        dispatch(getTalentosThunk({ page, search }));
        toast.success('Talento actualizado exitosamente');
        // Abrir modal de vista con el registro actualizado
        await dispatch(getTalentoByIdThunk(selectedTalento.id));
        dispatch(openViewModal());
      }
    }
  };

  return (
    <Modal
      open={formModalOpen}
      onClose={() => dispatch(closeFormModal())}
      title={formMode === "create" ? "Crear nuevo talento" : "Editar talento"}
      size="lg"
    >
      {formLoading ? (
        <Loader
          center
          type="dots"
          text={
            formMode === "create"
              ? "Creando talento..."
              : "Actualizando talento..."
          }
        />
      ) : (
        <form onSubmit={handleSubmit}>
          {formError && <Alert message={formError} variant="error" />}

          <div className="mb-3">
            <label className="form-label fw-medium">
              Nombre <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className="form-control"
              name="nombre"
              value={formData.nombre}
              onChange={handleChange}
              placeholder="Ingrese el nombre del talento"
              required
            />
          </div>

          <div className="mb-3">
            <label className="form-label fw-medium">
              Descripción <span className="text-danger">*</span>
            </label>
            <textarea
              className="form-control"
              name="descripcion"
              value={formData.descripcion}
              onChange={handleChange}
              placeholder="Ingrese la descripción del talento"
              rows="6"
              required
            />
          </div>

          <div className="d-flex align-items-center justify-content-end gap-3">
            <button
              type="button"
              className="btn btn-outline-secondary px-20 py-11"
              onClick={() => dispatch(closeFormModal())}
            >
              Cancelar
            </button>
            <button type="submit" className="btn btn-primary px-20 py-11">
              {formMode === "create" ? "Crear" : "Actualizar"}
            </button>
          </div>
        </form>
      )}
    </Modal>
  );
};

export default TalentoFormModal;
